import Index from "../../pages/snail/questionnaire/index";

const base = "questionnaire";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/questionnaire.js